import { render, staticRenderFns } from "./WhatsAppConnect.vue?vue&type=template&id=3597d8fd&scoped=true&"
import script from "./WhatsAppConnect.vue?vue&type=script&lang=js&"
export * from "./WhatsAppConnect.vue?vue&type=script&lang=js&"
import style0 from "./WhatsAppConnect.vue?vue&type=style&index=0&id=3597d8fd&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3597d8fd",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
installComponents(component, {VBtn})
